import { IoChevronForwardOutline } from "react-icons/io5";
import { Link, useOutletContext, useParams } from "react-router";
import styled from "styled-components";

import BimClassLink from "./BimClassLink";
import Editor from "./Editor";
import Revisions from "./Revisions";
import Title from "./Title";
import { TAXONOMY_BASE } from "../../../../../constants";
import { CssSectionCard } from "../../../components/styles";
import GeometryTypes from "../../BimClass/BimClassDetail/GeometryTypes";

import type { BimClassOutletContext } from "../../BimClass/WithBimClassInventory";

const StyledGeometryTypeDetail = styled.div`
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 280px 320px 1fr;
    gap: 20px;
    height: 100%;
    min-height: 0;
    overflow: hidden;

    .section-card {
        ${ CssSectionCard }
    }

    .nav-breadcrumbs {
        align-items: center;
        display: flex;
        gap: 6px;
        font-size: 0.8rem;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #ebecf0;

        a {
            color: #6b778c;
            text-decoration: none;
            font-weight: 500;

            &:hover {
                color: #0052cc;
            }
        }

        svg {
            color: #a5adba;
            font-size: 0.75rem;
        }

        .current {
            color: #172b4d;
            font-weight: 600;
        }
    }
`;

export default function GeometryTypeDetail() {
    const { bimClassID, geometryTypeID, geometryTypeRevisionID } = useParams();
    const guard = useOutletContext<BimClassOutletContext>();

    return (
        <StyledGeometryTypeDetail>
            {/* Section 1: Geometry Types & Nav */}
            <div className="section-card">
                <div className="nav-breadcrumbs">
                    <Link to={ TAXONOMY_BASE }>Home</Link>
                    <IoChevronForwardOutline />
                    <Link to={ `${ TAXONOMY_BASE }/BimClasses` }>BimClasses</Link>
                    <IoChevronForwardOutline />
                    <BimClassLink id={ bimClassID } />
                </div>
                <GeometryTypes
                    guard={ guard }
                    id={ bimClassID }
                />
            </div>

            {/* Section 2: Revisions & Title */}
            <div className="section-card">
                <Title
                    id={ geometryTypeID }
                    revisionID={ geometryTypeRevisionID }
                />
                <Revisions
                    guard={ guard }
                    id={ geometryTypeID }
                    revisionID={ geometryTypeRevisionID }
                />
            </div>

            {/* Section 3: Geometry Type Editor */}
            <div className="section-card">
                <Editor
                    guard={ guard }
                    id={ geometryTypeID }
                    key={ geometryTypeRevisionID }
                    revisionID={ geometryTypeRevisionID }
                />
            </div>
        </StyledGeometryTypeDetail>
    );
}
